import React from "react";
import { CircularProgress, styled } from '@material-ui/core';
import { User } from "../../../types";

import { actions } from '../../../services/userChats';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { RootState } from "../../../store";
import ChatItem from "./ChatItem";

import { FixedSizeList } from 'react-window';
import { ReactWindowScroller } from '../../../components/WindowScroller';


const Root = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  flex: 1,
});

interface Props {
  user: User;
}

const UserChats: React.FC<Props> = ({ user }) => {

  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.userChats);
  

  useEffect(() => {
    dispatch(actions.loadChats(user.id));

    return () => {
      dispatch(actions.resetChats())
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ user.id ]);

  if (state.chatsLoading) {
    return (
      <Root>
        <CircularProgress />
      </Root>
    );
  }




  return (
    <Root>
      <ReactWindowScroller>
        {({ ref, outerRef, style, onScroll }) => (
          <FixedSizeList
            ref={ref}
            outerRef={outerRef}
            style={style}
            onScroll={onScroll}
            height={window.innerHeight}
            width="100%"
            itemCount={state.chats.length}
            itemSize={190}
            itemData={state.chats}
          >
            {ChatItem}
          </FixedSizeList>
        )}
      </ReactWindowScroller>
    </Root>
  );




};

// export default memo(UserChats, areEqual);
export default UserChats;